import React, { FC } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { ProductModel } from '../../../../../../shared/orders/product';
import { MaterialIcon } from '../../../../../components';
import { useTranslation } from '../../../../../translations';
import { ImageListItemComponent } from './ImageListItemComponent';

interface ImageListProps {
  readonly product: ProductModel;
  readonly onAdd: () => void;
  readonly onUpdate: () => void;
}

export const ImageListComponent: FC<ImageListProps> = ({
  product: { id, images, canAddMoreImages, deletedAt },
  onAdd,
  onUpdate,
}) => {
  const { ts } = useTranslation();
  return (
    <Card className="mt-10" id="productImages">
      <CardHeader>
        <div className="card-sub-header">{ts('product_images')}</div>
        {!deletedAt && canAddMoreImages && (
          <div className="float-end">
            <Button color="success" id="create" onClick={onAdd} title={ts('common.create')}>
              <MaterialIcon name="add" />
            </Button>
          </div>
        )}
      </CardHeader>
      <CardBody>
        <Row>
          {images.length === 0 && (
            <Col xs={12}>
              <i>{ts('there_are_no_images_for')}</i>
            </Col>
          )}
          {images.map((image) => (
            <ImageListItemComponent
              image={image}
              key={image.id}
              onUpdate={onUpdate}
              productId={id}
            />
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};
